/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewBuiltwithRecord } from './CRSFSecReviewBuiltwithRecord';
import {
    CRSFSecReviewBuiltwithRecordFromJSON,
    CRSFSecReviewBuiltwithRecordFromJSONTyped,
    CRSFSecReviewBuiltwithRecordToJSON,
} from './CRSFSecReviewBuiltwithRecord';
import type { CRSFSecReviewBuiltwithRecordItem } from './CRSFSecReviewBuiltwithRecordItem';
import {
    CRSFSecReviewBuiltwithRecordItemFromJSON,
    CRSFSecReviewBuiltwithRecordItemFromJSONTyped,
    CRSFSecReviewBuiltwithRecordItemToJSON,
} from './CRSFSecReviewBuiltwithRecordItem';

/**
 * 
 * @export
 * @interface Builtwith1
 */
export interface Builtwith1 {
    /**
     * 
     * @type {Array<CRSFSecReviewBuiltwithRecordItem>}
     * @memberof Builtwith1
     */
    Results?: Array<CRSFSecReviewBuiltwithRecordItem>;
    /**
     * 
     * @type {number}
     * @memberof Builtwith1
     */
    created: number;
    /**
     * 
     * @type {string}
     * @memberof Builtwith1
     */
    domain: string;
    /**
     * 
     * @type {string}
     * @memberof Builtwith1
     */
    process_id: string;
}

/**
 * Check if a given object implements the Builtwith1 interface.
 */
export function instanceOfBuiltwith1(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "domain" in value;
    isInstance = isInstance && "process_id" in value;

    return isInstance;
}

export function Builtwith1FromJSON(json: any): Builtwith1 {
    return Builtwith1FromJSONTyped(json, false);
}

export function Builtwith1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Builtwith1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'Results': !exists(json, 'Results') ? undefined : ((json['Results'] as Array<any>).map(CRSFSecReviewBuiltwithRecordItemFromJSON)),
        'created': json['created'],
        'domain': json['domain'],
        'process_id': json['process_id'],
    };
}

export function Builtwith1ToJSON(value?: Builtwith1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Results': value.Results === undefined ? undefined : ((value.Results as Array<any>).map(CRSFSecReviewBuiltwithRecordItemToJSON)),
        'created': value.created,
        'domain': value.domain,
        'process_id': value.process_id,
    };
}

